
// eslint-disable-next-line import/prefer-default-export
export const slugify = (str) => str
  .toLowerCase()
  .trim()
  .replace(/[^\w\s-]/g, '')
  .replace(/[\s_-]+/g, '-')
  .replace(/^-+|-+$/g, '');


export const truncate = (str, length) => (
  str.length > length ? `${str.substring(0, length)}...` : str
);
